// extracted by mini-css-extract-plugin
export default {"frameContainer":"FramedDashboard_frameContainer__b5FO4","loading":"FramedDashboard_loading__pHj+z","quiet":"FramedDashboard_quiet__QlfE+","frame":"FramedDashboard_frame__U4DvC"};